import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'redux-form';

// Form
import { RenderCheckboxList } from '../../../../../../../../../../forms';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    options?: string[];
}

export class DescriptionSnippetsCheckboxGroup extends React.PureComponent<Props> {
    render() {
        const { options } = this.props;
        return (
            <Field
                name="description"
                component={RenderCheckboxList}
                placeholder="Description"
                options={options}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    options: selectOptions
});

export default connect(mapStateToProps)(DescriptionSnippetsCheckboxGroup);
